import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface ClicksIconProps {
  size?: number
  color?: string
  className?: string
  onClick?: () => void
}

const ClicksIcon: React.FC<ClicksIconProps> = ({
  size = 24,
  color = colors.PRIMARY,
  className,
  onClick,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path
        d='M11.5596 18.345C8.37961 18.195 5.84961 15.575 5.84961 12.355C5.84961 9.04498 8.53961 6.35498 11.8496 6.35498C15.0696 6.35498 17.6896 8.88498 17.8396 12.065L15.7396 11.435C15.3296 9.66498 13.7396 8.35498 11.8496 8.35498C9.63961 8.35498 7.84961 10.145 7.84961 12.355C7.84961 14.245 9.15961 15.835 10.9296 16.245L11.5596 18.345ZM21.8496 12.355C21.8496 12.655 21.8396 12.955 21.8096 13.255L19.8396 12.665C19.8496 12.565 19.8496 12.455 19.8496 12.355C19.8496 7.93498 16.2696 4.35498 11.8496 4.35498C7.42961 4.35498 3.84961 7.93498 3.84961 12.355C3.84961 16.775 7.42961 20.355 11.8496 20.355C11.9496 20.355 12.0596 20.355 12.1596 20.345L12.7496 22.315C12.4496 22.345 12.1496 22.355 11.8496 22.355C6.32961 22.355 1.84961 17.875 1.84961 12.355C1.84961 6.83498 6.32961 2.35498 11.8496 2.35498C17.3696 2.35498 21.8496 6.83498 21.8496 12.355ZM18.0796 16.615L20.3496 15.855C20.8096 15.705 20.7996 15.045 20.3396 14.905L12.7396 12.625C12.3596 12.515 11.9996 12.865 12.1196 13.245L14.3996 20.845C14.5396 21.315 15.1996 21.325 15.3496 20.855L16.1096 18.585L20.0196 22.495C20.2196 22.695 20.5296 22.695 20.7296 22.495L21.9996 21.225C22.1996 21.025 22.1996 20.715 21.9996 20.515L18.0796 16.615Z'
        fill={color}
      />
    </svg>
  )
}

export default ClicksIcon
